import { Box, styled } from '@mui/material';
import CountUp from 'react-countup';

import { ChartContainer, ChartContainerProps } from './GridContainer';

const CHART_DIMENSIONS = {
  big: {
    height: 400,
    width: 800,
  },
  default: {
    height: 200,
    width: 800,
  },
  small: {
    height: 200,
    width: 382,
  },
};

type Props = {
  data: {
    label: string;
    type: 'currency' | 'number' | 'string';
    value: number | string;
  }[];
} & Pick<ChartContainerProps, 'description' | 'empty' | 'title'>;

const Data = styled('div')(({ theme }) => ({
  alignItems: 'center',
  background: theme.palette.secondary.dark,
  borderRadius: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  margin: theme.spacing(1),
  padding: theme.spacing(1.5),
  [theme.breakpoints.down('xl')]: {
    width: '100%',
  },
  width: 'fit-content',
}));

const Label = styled('span')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '0.9rem',
  fontWeight: 900,
}));

const Value = styled(CountUp)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

const StyledContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  height: `${CHART_DIMENSIONS.small.height}px`,
  justifyContent: 'center',
  minWidth: `${CHART_DIMENSIONS.small.width}px`,
  [theme.breakpoints.between('md', 'xl')]: {
    '& > div': {
      margin: '8px auto',
      width: 'calc(100% - 16px)',
    },
    flexDirection: 'column',
    minWidth: 'unset',
  },
  [theme.breakpoints.between(601, 'md')]: {
    flexDirection: 'column',
    minWidth: '300px',
  },
}));

export const StatsChart = ({ data, description, empty, title }: Props) => (
  <ChartContainer description={description} dimension="small" empty={empty} title={title}>
    <StyledContainer>
      {data.map(({ label, type, value }) => (
        <Data key={label}>
          <Label>{label}</Label>
          {type === 'number' || type === 'currency' ? (
            <Value duration={2} end={value as number} />
          ) : (
            value
          )}
        </Data>
      ))}
    </StyledContainer>
  </ChartContainer>
);
